/**
 * The status line (docs/spec/04 §4): one 8-pixel row across the top, laid out on the C64's 40
 * columns and centred when the screen is wider.
 */

import type { Screen } from './screen';
import { WHITE, YELLOW } from './palette';

export interface PlayStatus {
  readonly quota: number;
  readonly value: number;
  readonly extraValue: number;
  readonly diamonds: number;
  readonly gateOpen: boolean;
  readonly time: number;
  readonly score: number;
}

function pad(n: number, width: number): string {
  return String(Math.max(0, Math.floor(n))).padStart(width, '0');
}

/** Left edge of the 40-column layout on a screen `width` pixels wide. */
function origin(width: number): number {
  return Math.max(0, Math.floor((width - 320) / 2));
}

export function drawPlayStatus(screen: Screen, st: PlayStatus): void {
  screen.fill(0, 0, screen.width, 8, 0);
  const x = origin(screen.width);
  const at = (col: number): number => x + col * 8;
  if (st.gateOpen) {
    screen.text('◆◆◆', at(2), 0, YELLOW);
    screen.text(pad(st.extraValue, 2), at(5), 0, WHITE);
  } else {
    screen.text(pad(st.quota, 2), at(3), 0, YELLOW, 'left');
    screen.text('◆', at(5), 0, WHITE);
    screen.text(pad(st.value, 2), at(6), 0, WHITE);
  }
  screen.text(pad(st.diamonds, 2), at(14), 0, YELLOW);
  screen.text(pad(st.time, 3), at(22), 0, WHITE);
  screen.text(pad(st.score, 6), at(31), 0, WHITE);
}

/** A message across the line, e.g. `PLAYER 1,  3 MEN,  A/1` or `OUT OF TIME`. */
export function drawStatusText(screen: Screen, text: string, colour: number = WHITE): void {
  screen.fill(0, 0, screen.width, 8, 0);
  screen.text(text, Math.floor(screen.width / 2), 0, colour, 'center');
}
